import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

// GenerateObraAlvenariaEstruturalColumns

type Props = {
  onActionEditar: (IdAlvenariaObra: number | null, openState: boolean) => void,
  onActionDeletar: (IdAlvenariaObra: number | null, openState: boolean) => void,
};

export const GenerateObraAlvenariaEstruturalColumns = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {
  return [
    {
      field: "DataRecebimento",
      filterable: false,
      headerName: "Data recebimento",
      flex: 1,
      minWidth: 120,
      sortable: false,
      headerClassName: 'funcionarios-header',
      valueFormatter: (params) => {
          if (!params) return "";
          return new Intl.DateTimeFormat("pt-BR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
          }).format(new Date(params));
      },
    },
    {
      field: "Dimensao",
      filterable: false,
      headerName: "Dimensao",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "TipoBloco",
      filterable: false,
      headerName: "Tipo Bloco",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "NroNotaFiscal",
      filterable: false,
      headerName: "Nº Nota Fiscal",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "ResistenciaSolicitada",
      filterable: false,
      headerName: "Resistência Solicitada",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "QtdeRecibida",
      filterable: false,
      headerName: "Quantidade Recibida",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "Fornecedor",
      filterable: false,
      headerName: "Fornecedor",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "LocalAplicacao",
      filterable: false,
      headerName: "Local de Aplicação",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "NomeLaboratorio",
      filterable: false,
      headerName: "Laboratório",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "DataEnvio",
      filterable: false,
      headerName: "Data do Envio",
      flex: 1,
      minWidth: 120,
      sortable: false,
      headerClassName: 'funcionarios-header',
      valueFormatter: (params) => {
          if (!params) return "";
          return new Intl.DateTimeFormat("pt-BR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
          }).format(new Date(params));
      },
    },
    {
      field: "Aprovado",
      filterable: false,
      headerName: "Aprovado?",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header status-header',
      valueFormatter: (params) => {
        if (params === true) return 'Sim';
        if (params === false) return 'Não';
        return ''; 
      },
    },
    {
      field: "FuncionarioNome",
      filterable: false,
      headerName: "Aprovado por?",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header status-header',
    },
    {
      field: 'IdAlvenariaObra',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEditar(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}